import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


const state = {
    error:null,
    maintenanceMode: false,
    limitError: false,
}
const mutations = {
    SET_ERROR(state,payload){
        state.error = payload
    },
    CLEAR_ERROR(state){
        state.error = null
    },
    SET_MAINTENANCE_MODE(state, payload) {
        state.maintenanceMode = payload;
    },
    SET_LIMIT_ERROR(state, payload) {
        state.limitError = payload;
    },
}

const actions = {
    setError({commit, dispatch}, payload){
        commit('SET_ERROR',payload)
    },
    setMaintanceMode({commit, dispatch}, payload) {
        commit('SET_MAINTENANCE_MODE', payload)
    },
    setLimitError({commit, dispatch}, payload) {
        commit('SET_LIMIT_ERROR', payload)
    },
    clearErrors({commit}){
        commit('CLEAR_ERROR')
    }
}

export default {
    state,
    mutations,
    actions
}